import styled, { css } from 'styled-components';

import {
    Button,
    Label,
    mediaMixin,
    ModalDialog,
    spaceMixin,
    Text,
    TextButton,
    token,
} from '@zillow/constellation';

export const baseFontStyle = css`
    font-size: 14px;

    ${mediaMixin('lg', css`
        font-size: 16px;
    `)};
`;

export const StyledWrapper = styled.div`
    margin: 0 auto;
    max-width: 600px;
    text-align: center;
`;

export const StyledModalDialog = styled(ModalDialog)`
    && section {
        min-height: 400px;
    }
`;

export const StyledEditButton = styled(TextButton)`
    ${baseFontStyle}
    font-weight: 400;
`;

export const StyledErrorText = styled(Text)`
    color: ${token('colors.red400')};
    line-height: 18px;
    text-align: center;
`;

export const StyledCTALabel = styled(Label)`
    && {
        ${baseFontStyle}
        display: block;
        font-weight: 700;
        margin-bottom: ${spaceMixin('xs')};

        ${mediaMixin('lg', css`
            margin-bottom: ${spaceMixin('sm')};
        `)};
    }
`;

export const StyledText = styled(Text)`
    && {
        ${baseFontStyle}
    }
`;

export const StyledCTAWrapper = styled.div`
    margin: ${spaceMixin('sm')} auto 0px;

    ${mediaMixin('lg', css`
        margin-top: ${spaceMixin('lg')} 0px;
    `)};
`;

export const StyledFullWidthButton = styled(Button)`
    min-width: 200px;
    display: block;
    margin: 0 auto;
`;
